import React, { useState, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import { LanguageContext } from "App";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
const index = ({ Session, setShowEdit }) => {
  const { translations } = useContext(LanguageContext);
  return (
    <div className="mb-3 col-md-12">
      <div className="card">
        <Card sx={{ height: "100%", boxShadow: !false && "none" }} className="mb-3 ">
          <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              {translations.sessionPgSessionsSessionInfo} :
            </MDTypography>
            <MDTypography variant="body2" color="secondary">
              <Tooltip title={"Edit Session"} onClick={() => setShowEdit(true)} placement="top">
                <Icon>edit</Icon>
              </Tooltip>
            </MDTypography>
          </MDBox>

          <div className="container-fluid my-3 px-3">
            <div className="row">
              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.FacilityPagesCreatenewFacilityTypename}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.name}
                </MDTypography>
              </div>
              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.FacilityPagesCreatenewFacilityTypedescription}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.description}
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.FacilityPagesCreatenewFacilityTypecategory}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.category}
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsSecretName}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.secretName}
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsEgyptianPrice}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.egyptianPrice}
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsArabPrice}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.arabPrice}
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsOtherPrice}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.otherPrice}
                </MDTypography>
              </div>

              <div className="col-md-4">
                {/* <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsIsHalfDuration}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  <input id={"S.IsHalfDurationDisabled" + Session.id}
                    type="checkbox"
                    defaultChecked={Session.isHalfDuration}
                    disabled={true}
                  />
                </MDTypography> */}
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsAssesmentSession}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  <input
                    id={"S.IsAssessmentDisabled" + Session.id}
                    type="checkbox"
                    defaultChecked={Session.isAssessmentSession}
                    disabled={true}
                  />
                </MDTypography>
              </div>

              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.FacilityPagesCreatenewFacilityTypeImage}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;
                  {Session.image && (
                    <img
                      style={{ width: "6em", height: "6em" }}
                      id={"image" + Session.id}
                      src={"data:image/png;base64," + Session.image}
                    ></img>
                  )}
                </MDTypography>
              </div>
              <div className="col-md-4">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.sessionPgSessionsSessionId}: &nbsp;
                </MDTypography>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Session.id}
                </MDTypography>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default index;
